var map = {
	"./alert.svg": "a682",
	"./alias.svg": "96a8",
	"./analogo.svg": "657e",
	"./battery.svg": "4e19",
	"./blood-bag.svg": "8ac7",
	"./card-text.svg": "4e6e",
	"./clock.svg": "f396",
	"./co2.svg": "4d80",
	"./co2_blue.svg": "ce07",
	"./co2_gray.svg": "0ed7",
	"./co2_red.svg": "a37b",
	"./contact.svg": "bc24",
	"./cpu.svg": "c226",
	"./distance.svg": "42e5",
	"./email.svg": "c156",
	"./envtemperature.svg": "9e8c",
	"./fecha.svg": "cd54",
	"./georeference.svg": "3d2b",
	"./group.svg": "450b",
	"./home-device-icon.svg": "dcdc",
	"./humedad.svg": "5f42",
	"./humedad_blue.svg": "a771",
	"./humedad_gray.svg": "db2b",
	"./humedad_red.svg": "0d27",
	"./humidity.svg": "b197",
	"./label.svg": "1cea",
	"./medical-bag.svg": "3f51",
	"./needle.svg": "7416",
	"./notification.svg": "ee71",
	"./panicbutton.svg": "6736",
	"./phone.svg": "10d8",
	"./pill.svg": "3b89",
	"./pointtracker.svg": "9eb7",
	"./pressure.svg": "a7cc",
	"./pressure_blue.svg": "6fae",
	"./pressure_gray.svg": "7bc0",
	"./pressure_label.svg": "2c56",
	"./pressure_red.svg": "d577",
	"./relationship.svg": "6c25",
	"./relay.svg": "9911",
	"./spore_icon.svg": "4df0",
	"./statistics.svg": "a782",
	"./temperature.svg": "bdc1",
	"./temperature_blue.svg": "539a",
	"./temperature_gray.svg": "6bd3",
	"./temperature_red.svg": "667f",
	"./tick-icon.svg": "4521"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32da";